// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22L2 22V2H22ZM18 7.5L6 7.5V9.5L18 9.5V7.5ZM14 11.5L6 11.5V13.5L14 13.5V11.5Z"}}]};

const RootListFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'root-list-filled',
    ref,
    icon: element,
  },
));

RootListFilledIcon.displayName = 'RootListFilledIcon';

export default RootListFilledIcon;
